import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import Sidebar from "../../components/Sidebar"
import { setLanguage } from "redux-i18n";
import * as modalActions from "../../redux/actions/modalActions";
import * as commonActions from "../../redux/actions/commonAction";
import FileUploadHistoryComponent from "../../components/FileUploadHistory";
import * as profileActions from "../../redux/actions/profileAction";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionComponent";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";

const FileUploadHistory = (props, context) => {
    const profileReducer = useSelector((state) => state.profileReducer);
    const commonReducer = useSelector((state) => state.commonReducer);

    const dispatch = useDispatch();
    const commonAction = bindActionCreators(commonActions, dispatch);

    const getFileHistory = () => {
        //commonAction.getFileHistory(props.fileLevel);
    }
    const resetFileHistory = () => {
        commonAction.resetFileHistory();
    }

    return (
        <>
            <div className="Content-Panel">
                {commonReducer.fileHistory && commonReducer.fileHistory.length > 0 ?
                    <FileUploadHistoryComponent
                        {...props}
                        fileHistoryDetails={props.history}
                        getFileHistory={getFileHistory}
                        resetFileHistory={resetFileHistory}
                        context={props.context}
                    /> : null
                }
            </div>
        </>
    )
}


export default FileUploadHistory;